import * as THREE from "three";

export const materialPhysical = new THREE.MeshPhysicalMaterial();

export const materialObject = {
  materialPhysical,
};
